import { doc } from 'prettier'
import React, { useEffect, useState } from 'react'
import useMarketo from '../../hooks/useMarketo'
import {
  marketoFormContainer,
  marketoFormHeader,
  marketoFormTitle,
  marketoFormSubtitle,
} from './index.module.css'

const MarketoForm = ({ title, subtitle, contactForm_ref }) => {
  const [loading, setLoading] = useState(true)
  const { formId, loadingText, marketoId, redirect } = contactForm_ref
  useMarketo({
    baseUrl: '//893-FVD-854.mktoweb.com',
    munchkinId: marketoId,
    formId: formId,
    callback: () => {
      setLoading(false)
    },
    redirect: redirect,
  })

  return (
    <div className="wrapper">
      <section className={[marketoFormContainer, 'hubspotForm'].join(' ')}>
        <div className={marketoFormHeader}>
          {title && <h2 className={marketoFormTitle}>{title}</h2>}
          {subtitle && (
            <div className={marketoFormSubtitle}>
              {subtitle.subtitle.split('\n')[0]}
            </div>
          )}
        </div>
        {formId && (
          <>
            <div style={{ display: loading ? 'flex' : 'none' }}>
              {loadingText ? loadingText : 'Loading'}
            </div>

            <form id={`mktoForm_${formId}`} />
          </>
        )}
      </section>
    </div>
  )
}

export default MarketoForm
